// frontend/src/utils/firewallInstructions.js

/**
 * Instrucciones de firewall por cloud provider
 * Para agregar IP de DatiaFlow: 13.219.9.121
 */

export const DATIAFLOW_IP = '13.219.9.121';
export const DATIAFLOW_IP_CIDR = '13.219.9.121/32';

export const firewallProviders = {
  aws: {
    label: 'AWS EC2 / RDS',
    icon: '☁️',
    steps: [
      'Ve a tu consola AWS',
      'RDS → Instancia BD → Security Groups',
      'Edit Inbound Rules → Add Rule',
      'Type: PostgreSQL (5432) o MySQL (3306)',
      'Source: 13.219.9.121/32',
      'Save Rules',
      'Espera 1-2 minutos',
    ],
    details: `
    Para RDS específicamente:
    1. Console AWS → RDS → Databases
    2. Selecciona tu BD
    3. Security Group → Modify
    4. Inbound Rules → Add Rule
       - Type: PostgreSQL / MySQL
       - Port: 5432 / 3306
       - Source: 13.219.9.121/32
    5. Save
    `,
  },
  azure: {
    label: 'Azure (Database for PostgreSQL/MySQL)',
    icon: '☁️',
    steps: [
      'Azure Portal → Tu base de datos',
      'Connection security → Firewall Rules',
      'Add Client IP (pero usa 13.219.9.121)',
      'Guardar',
    ],
    details: `
    Para Azure Database:
    1. Portal → PostgreSQL / MySQL resource
    2. Connection security
    3. Add firewall rule:
       - Rule Name: DatiaFlow
       - Start IP: 13.219.9.121
       - End IP: 13.219.9.121
    4. Save
    `,
  },
  gcp: {
    label: 'Google Cloud SQL',
    icon: '☁️',
    steps: [
      'Google Cloud Console',
      'SQL Instances → Tu instancia',
      'Connections → Networking',
      'Authorized Networks → Add Network',
      'Network: 13.219.9.121/32',
      'Save',
    ],
    details: `
    Para Google Cloud SQL:
    1. Console → Cloud SQL → Instances
    2. Selecciona tu instancia
    3. Connections tab
    4. Networking → Authorized networks
    5. Add Network:
       - 13.219.9.121/32
    6. Save
    `,
  },
  linode: {
    label: 'Linode / Akamai',
    icon: '☁️',
    steps: [
      'Linode Cloud Manager',
      'Firewall → Add Rule',
      'Label: DatiaFlow',
      'Protocol: TCP',
      'Port: 5432 (PostgreSQL) / 3306 (MySQL)',
      'Inbound → Source: 13.219.9.121/32',
      'Save Rules',
    ],
    details: `
    Para Linode Firewall:
    1. Cloud Manager → Firewalls
    2. Select o Create Firewall
    3. Inbound Rules → Add Rule
       - Label: DatiaFlow
       - Protocol: TCP
       - Ports: 5432 (PG) o 3306 (MySQL)
       - Sources: 13.219.9.121/32
    4. Save

    Nota: Si tu BD está en un Linode Managed Database,
    ve a: Databases → DB Instance → Network Access
    `,
  },
  ovh: {
    label: 'OVH Cloud',
    icon: '☁️',
    steps: [
      'OVH Control Panel',
      'Cloud → Databases',
      'Tu instancia BD',
      'Network access → Agregar acceso',
      'IP: 13.219.9.121/32',
      'Guardar',
    ],
    details: `
    Para OVH:
    1. OVH Panel → Cloud → Databases
    2. Selecciona tu BD
    3. Network access tab
    4. Add access:
       - IP/CIDR: 13.219.9.121/32
    5. Save
    `,
  },
  digitalocean: {
    label: 'DigitalOcean',
    icon: '☁️',
    steps: [
      'DigitalOcean Console',
      'Databases → Tu DB',
      'Networking → Trust Sources',
      'Add Trusted Source',
      'IP: 13.219.9.121/32 (o 13.219.9.121)',
      'Save',
    ],
    details: `
    Para DigitalOcean:
    1. Console → Databases
    2. Selecciona tu DB
    3. Networking tab
    4. Trusted Sources → Edit
    5. Add source: 13.219.9.121
    6. Save
    `,
  },
  onpremise: {
    label: 'On-Premise / Servidor Propio',
    icon: '🔒',
    steps: [
      'Accede a tu servidor (SSH/RDP)',
      'Abre el firewall (iptables, firewalld, etc)',
      'Allow TCP port 5432 o 3306 from 13.219.9.121',
      'Asegúrate que BD escucha en red pública (no localhost)',
    ],
    details: `
    Para Linux (iptables):
    sudo iptables -A INPUT -p tcp --dport 5432 -s 13.219.9.121 -j ACCEPT
    sudo iptables -A INPUT -p tcp --dport 3306 -s 13.219.9.121 -j ACCEPT

    Para Linux (firewalld):
    sudo firewall-cmd --permanent --add-rich-rule='rule family="ipv4" source address="13.219.9.121" port protocol="tcp" port="5432" accept'

    Para Windows Firewall:
    New-NetFirewallRule -DisplayName "DatiaFlow" -Direction Inbound -Action Allow -Protocol TCP -LocalPort 5432 -RemoteAddress 13.219.9.121
    `,
  },
  custom: {
    label: 'Otro Provider',
    icon: '?',
    steps: [
      'Accede a tu panel de control',
      'Busca "Firewall" o "Network" o "Security Groups"',
      'Agrega una regla de ingreso',
      'Protocolo: TCP',
      'Puerto: 5432 (PostgreSQL) / 3306 (MySQL)',
      'Origen (CIDR): 13.219.9.121/32',
    ],
    details: 'Si tu provider no está listado, los pasos son generalmente los mismos.',
  },
};

/**
 * Obtener proveedor por nombre corto
 */
export function getFirewallProvider(providerKey) {
  return firewallProviders[providerKey] || firewallProviders.custom;
}

/**
 * Obtener lista de proveedores para UI
 */
export function getProvidersList() {
  return Object.entries(firewallProviders).map(([key, value]) => ({
    key,
    ...value,
  }));
}

/**
 * Generar texto para copiar/compartir
 */
export function generateFirewallInstructions(providerKey, dbPort = 5432) {
  const provider = getFirewallProvider(providerKey);
  return `
DatiaFlow Firewall Setup
Provider: ${provider.label}
IP: ${DATIAFLOW_IP}
Port: ${dbPort}

${provider.steps.map((step, i) => `${i + 1}. ${step}`).join('\n')}

${provider.details}
  `.trim();
}